module.exports = __webpack_public_path__ + "img/113.0d2c01dd.jpg";